import Button from '@mui/material/Button';
import React from 'react';

import { RouteEnum } from '@/models/route/Route.model.ts';
import { useAppNavigation } from '@/utils/useAppNavigation.util.ts';
import { useTranslationWithPrefix } from '@/utils/useTranslationWithPrefix.ts';

type Props = {
  label?: string;
};

export const ContactsHeaderAdd: React.FC<Props> = props => {
  const { t } = useTranslationWithPrefix('views.contacts.header');
  const { push } = useAppNavigation();

  const handleClick = () => {
    push(RouteEnum.CONTACTS_CREATE);
  };

  return (
    <Button onClick={handleClick} variant="outlined">
      {props.label ?? t('button.add')}
    </Button>
  );
};
